var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJournalCombination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497 187.274h-168.096c-8.284 0-15 6.716-15 15v143.542h-42.549v-170.003c0-8.284-6.716-15-15-15h-58.26v-145.813c0-8.284-6.716-15-15-15h-168.095c-8.284 0-15 6.716-15 15v294.726c0 8.284 6.716 15 15 15h168.095c8.284 0 15-6.716 15-15v-118.913h43.26v170.004c0 8.284 6.716 15 15 15h57.549v121.183c0 8.284 6.716 15 15 15h168.096c8.284 0 15-6.716 15-15v-294.726c0-8.284-6.716-15-15-15zm-467-157.274h138.095v199.292h-138.095zm138.095 264.726h-138.095v-35.433h138.095zm175.809-77.452h138.096v199.292h-138.096zm138.096 264.726h-138.096v-35.433h138.096z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.077 345.817h-42.25c-8.284 0-15 6.716-15 15s6.716 15 15 15h42.25c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.077 258.024h-42.25c-8.284 0-15 6.716-15 15s6.716 15 15 15h42.25c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.172 158.542h-42.25c-8.284 0-15 6.716-15 15s6.716 15 15 15h42.25c8.284 0 15-6.716 15-15s-6.715-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.172 70.75h-42.25c-8.284 0-15 6.716-15 15s6.716 15 15 15h42.25c8.284 0 15-6.716 15-15s-6.715-15-15-15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalCombination);
export default __webpack_public_path__ + "static/media/journal-combination.1819dc5fb05d87c1ae9017395b5cc55f.svg";
export { ForwardRef as ReactComponent };